import React from 'react';
import moment from 'moment';

import {
  SectionContainer,
  ContentWrapper,
  DriverInfoContainer,
  DriverInfoWrapper,
  InfoTitle,
} from '../styles';

const DeliverySection = ({
  driverInfo,
}) => (
  <SectionContainer>
    <ContentWrapper bordered backgroundColor="white">
      <DriverInfoContainer>
        <DriverInfoWrapper>
          <InfoTitle  color="#263465">Entrega prevista</InfoTitle>
          <InfoTitle medium minHeght={32} color="#292F36">{moment(driverInfo.tms.expectedDate || driverInfo.tms.progress.lastStatusDate).format('DD/MM/YYYY [às] HH:mm')}</InfoTitle>
        </DriverInfoWrapper>
        <DriverInfoWrapper>
          <InfoTitle  color="#263465">Endereço</InfoTitle>
          <InfoTitle medium minHeght={32} color="#292F36">{driverInfo.destination.address}</InfoTitle>
        </DriverInfoWrapper>
        <DriverInfoWrapper>
          <InfoTitle color="#263465">Cidade</InfoTitle>
          <InfoTitle medium color="#292F36">{`${driverInfo.destination.city}-${driverInfo.destination.state}`}</InfoTitle>
        </DriverInfoWrapper>
      </DriverInfoContainer>
    </ContentWrapper>
  </SectionContainer>
);

export default DeliverySection;
